import type { ComponentPropsWithoutRef } from 'react';
import { styled } from '@mui/material/styles';

import type { DiagramSeriesOption } from '@/features/time-series-chart/types/DiagramSeries.types';

type SeriesColorMarkerProps = ComponentPropsWithoutRef<'span'> & {
  seriesColor: string;
  valueType: DiagramSeriesOption['valueType'];
};

const Marker = styled('span', {
  shouldForwardProp: (prop) => prop !== 'seriesColor' && prop !== 'valueType',
})<SeriesColorMarkerProps>(({ theme, seriesColor, valueType }) => ({
  display: 'inline-block',
  flexShrink: 0,
  width: theme.spacing(1),
  height: theme.spacing(1),
  borderRadius: valueType === 'boolean' ? 0 : '50%',
  backgroundColor: seriesColor,
}));

export function SeriesColorMarker({ valueType, ...props }: SeriesColorMarkerProps) {
  return <Marker {...props} valueType={valueType} data-series-value-type={valueType} />;
}
